import {
  SET_COURSES,
  SET_COURSE_LOADING,
  SET_COURSE_DETAIL,
  SET_NEW_COURSE,
  DELETE_USER_FROM_COURSE,
  REMOVE_STUDENTS_FROM_COURSE,
  UPDATE_COURSE_DETAIL,
  DELETE_RT,
  CREATE_RT,
  DELETE_COURSE,
  ARCHIVE_COURSE,
  EDIT_ACTIVITY_IN_COURSE_STATE,
  SET_NEW_LIVE_DISCUSSION,
  ADD_STUDENT_TO_COURSE,
  SET_NEW_ONLINE_ROUNDTABLE,
  UPDATE_SUBSCRIPTION_TO_COURSE,
  SET_DASHBOARD_ROLE,
  UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION,
  IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION,
  DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION,
  DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION,
  SYNC_COURSES,
  TOOGLE_COURSE_CHAT,
  SEND_CHAT_MESSAGE,
  DELETE_CHAT_MESSAGE,
  DELETE_ALL_CHAT_MESSAGES,
  READ_COURSE_MESSAGES,
  UPDATE_COURSES_LIST,
  INVITE_CO_TEACHER
} from 'store/mutation-types';
import courseDetailsService from 'services/courses';
import roundtableService from 'features/onlineRoundtables/onlineRoundtables.services';
import liveDiscussionService from 'services/liveDiscussion';
import pinCourseService from 'features/dashboard/dashboard.services/pinCourse';
import sortBy from 'lodash/sortBy';
import get from 'lodash/get';
import { router } from 'vue';
import { EventBus } from 'utils/event-bus';
import googleClassroomService from 'services/googleClassroom/googleClassroomServices';
import adminServices from '../../services/admin/adminServices';
import inviteCoTeacher from 'services/courses/inviteCoTeacher';
import { SET_INSTRUCTOR_COURSES, SET_PARTICIPANT_COURSES } from '../mutation-types';
import loadUserInfo from 'app/services/account/completeInfo';

// Courses
export const addStudentToCourse = ({ commit }, user) => {
  commit(ADD_STUDENT_TO_COURSE, user);
  return courseDetailsService
    .courseDetails(user.subscription.course_id)
    .then((course) => {
      commit(SET_COURSE_DETAIL, course);
    });
};


export const duplicateLiveDiscussion = async ({ getters, dispatch }, payload) => {
  const { course_id, duplicate_id, isToCopy } = payload;
  const toast = { type: "", message: "", time: 5000};

  try {
    dispatch('setRTLoading', true);

    dispatch('analytics', 'create verbal discussion - create verbal discussion');

    const live_discussion = await liveDiscussionService.duplicateLiveDiscussion(duplicate_id, course_id, isToCopy);

    dispatch('addLiveDiscussionToCourseState', live_discussion);

    if (!getters.isPaidUser) {
      dispatch('useActivityPass');
    }

    dispatch('setRTLoading', false);

    return live_discussion;

  } catch (error) {
    console.error(error);
    toast.type = "Error";
    toast.message = "Something happened! Please try again";
    EventBus.$emit("createToast", toast);

  }
};

export const syncCourses = ({ commit }, payload) => {
  const { school_id } = payload;
  delete payload.school_id;
  return courseDetailsService.syncCourses(school_id, payload).then(({ data }) => {
    commit(SYNC_COURSES, data);
    return data;
  });
};
export const duplicateOnlineRoundtable = async ({ commit, getters, dispatch }, payload) => {
  const { duplicate_RT_id, courses, isToCopy } = payload;
  const toast = { type: "", message: "", time: 5000 };
  try {
    const roundtable = await roundtableService.duplicateRT(duplicate_RT_id, courses, isToCopy);
    if (roundtable && roundtable.length > 0) {
      commit(CREATE_RT, roundtable[0]);
      if (!getters.isPaidUser) {
        dispatch('useActivityPass', -roundtable.length);
      }
    }
    return roundtable;
  } catch (error) {
    console.error(error);
    toast.type = "Error";
    toast.message = "Something happened duplicating roundtable! Please try again!";
    EventBus.$emit("createToast", toast);
  }
};

export const toggleCourseChat = ({ getters, commit }, payload) => {
  const { courseID } = payload;
  payload.socket_id = getters.getProfile.socket_id;
  return courseDetailsService.toggleCourseChat(courseID, payload).then(() => {
    commit(TOOGLE_COURSE_CHAT);
  });
};

export const socketToggleCourseChat = ({ getters, commit }, payload) => {
  if (getters.getCourseDetail.id === payload.id) {
    commit(TOOGLE_COURSE_CHAT);
  }
};

export const socketSendChatMessage = ({ getters, commit }, payload) => {
  if (getters.getCourseDetail.id === payload.course_id) {
    commit(SEND_CHAT_MESSAGE, payload);
    commit(UPDATE_COURSE_DETAIL, { unread_messages: getters.getCourseDetail.unread_messages + 1 });
  }
};

export const socketLoadChatMessage = ({ getters, commit }, payload) => {
  if (getters.getCourseDetail.id === payload.course_id) {
    return courseDetailsService.loadChatMessage(payload.course_id, payload.id).then(({ data }) => {
      commit(SEND_CHAT_MESSAGE, data);
    });
  }
};

export const socketDeleteChatMessage = ({ getters, commit }, payload) => {
  const { course_id, id } = payload;
  if (getters.getCourseDetail.id === course_id) {
    commit(DELETE_CHAT_MESSAGE, id);
  }
};

export const socketDeleteAllChatMessages = ({ getters, commit }, payload) => {
  const { course_id } = payload;
  if (getters.getCourseDetail.id === course_id) {
    commit(DELETE_ALL_CHAT_MESSAGES, []);
  }
};

export const sendChatMessage = ({ commit, getters }, payload) => {
  const { courseID } = payload;
  payload.socket_id = getters.getProfile.socket_id;
  delete payload.courseID;
  return courseDetailsService.sendChatMessage(courseID, payload).then(({ data }) => {
    commit(SEND_CHAT_MESSAGE, data);
  });
};

export const inviteCoTeacherNotification = ({ commit, getters }, payload) => {
  const { courseID } = payload;
  payload.socket_id = getters.getProfile.socket_id;
  inviteCoTeacher(courseID, payload).then((res) => {
    commit(INVITE_CO_TEACHER, res);
  });

};

export const deleteChatMessage = ({ commit }, payload) => {
  const { courseID, id } = payload;
  return courseDetailsService.deleteChatMessage(courseID, id).then(() => {
    commit(DELETE_CHAT_MESSAGE, id);
  });
};
export const deleteAllChatMessages = (_, payload) => {
  const { courseID } = payload;
  return courseDetailsService.deleteAllChatMessages(courseID);
};

export const readCourseMessages = ({ commit }, payload) => {
  const { courseID } = payload;
  return courseDetailsService.readCourseMessages(courseID).then(() => {
    commit(READ_COURSE_MESSAGES);
  });
};

export const loadMoreMessages = (_, payload) => {
  const { courseID, pageNumber } = payload;
  return courseDetailsService.loadMoreMessages(courseID, pageNumber);
};

export const createOnlineRoundtable = ({ commit, getters, dispatch }, payload) => {
  return roundtableService
    .createRT(payload)
    .then(({ data }) => {
      const roundtable = data;
      commit(CREATE_RT, roundtable);
      dispatch('fetchRoundtable', roundtable.id);
      router.push({ name: 'roundtable.index', params: { courseID: payload.course_id, roundtableID: roundtable.id }, query: { newRT: true } });
      if (!getters.isPaidUser) {
        dispatch('useActivityPass');
      }
    })
    .catch((res) => {
      const message = get(res, 'response.data.message');
      if (message) {
        EventBus.$emit('toast-msg', message);
      }
    });
};



// Live Discussion Creation Action
export const createLiveDiscussion = ({ dispatch }, payload) => {
  // courseID = required, roundtable_id = optional, premade_id = optional
  const { courseID, roundtable_id, premade_id, title = 'Verbal Discussion', is_generated_by, sequence_id, draft_id } = payload;
  dispatch('analytics', 'create verbal discussion - create verbal discussion');
  dispatch('setRTLoading', true);
  return liveDiscussionService.createLiveDiscussion(courseID, title, roundtable_id, premade_id, is_generated_by, sequence_id, draft_id).then((live_discussion) => {
    dispatch('addLiveDiscussionToCourseState', live_discussion);
    /* if (!getters.isPaidUser) dispatch('useActivityPass'); */
    router.push({ name: 'live-discussion.index', params: { courseID, liveDiscussionID: live_discussion.id } });
    dispatch('setRTLoading', false);
    return live_discussion;
  });
};

export const fetchCourseDetails = ({ commit }, course_id) =>
  new Promise((resolve) => {
    commit(SET_COURSE_LOADING, true);
    return courseDetailsService
      .courseDetails(course_id)
      .then((course) => {
        commit(SET_COURSE_LOADING, false);
        commit(SET_COURSE_DETAIL, course);
        commit(UPDATE_COURSES_LIST, course);
        resolve(course);
      })
      .catch((error) => {
        // TODO: Redirect but fire off generic toast from the index
        if (error.response.status === 403) {
          EventBus.$emit('toast-msg', error.response.data.error);
        }
        if (error.response.data.show_cannot_access_roundtable_modal) {
          EventBus.$emit('removed_student_from_school', true);
        }
        router.push({ name: 'dashboard' });
        commit(SET_COURSE_LOADING, false);
        resolve();
      });
  });

export const setCourses = ({ commit }, courses) => {
  commit(SET_COURSES, courses);
};
// fetches course list
export const setCourseList = ({ commit }, role) => {
  // role: teacher or student
  return courseDetailsService.fetchCourseList(role).then(({ data }) => {
    const pinned = data.filter((c) => c.users[0].subscription.is_pinned);
    const pinned_created = pinned.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );
    const not_pinned = data.filter((c) => !c.users[0].subscription.is_pinned);
    const not_pinned_created = not_pinned.sort(
      (a, b) => new Date(b.created_at) - new Date(a.created_at)
    );

    const courses = [...pinned_created, ...not_pinned_created];

    commit(SET_COURSES, courses);
    commit(SET_DASHBOARD_ROLE, role);
    return data;
  });
};

export const handleSetInstructorCourses = async ({ commit }, { page, filter, search, type }) => {
  try {
    const number_page = page === undefined ? 1 : page;
    const search_course = search === '' ? undefined : search;
    const course_type = type !== 'All' ? type : 'All';
    
    const { data } = await courseDetailsService.FetchInstructorCourses(number_page, filter, search_course, course_type);
    commit(SET_DASHBOARD_ROLE, 'teacher');
    commit(SET_INSTRUCTOR_COURSES, data);
    return data;
  } catch (error) {
    return console.log(error);
  }
};

export const handleSetParticipantCourses = async ({ commit }, { role, page, filter, search, type }) => {
  try {
    const number_page = page === undefined ? 1 : page;
    const search_course = search === '' ? undefined : search;
    const course_type = type !== 'All' ? type : 'All';
    
    const { data } = await courseDetailsService.FetchParticipantCourses(number_page, filter, search_course, course_type);
    commit(SET_DASHBOARD_ROLE, role);
    commit(SET_PARTICIPANT_COURSES, data);
    return data;
  } catch (error) {
    return console.log(error);
  }
};

export const setDashboardRole = ({ commit }, role) => {
  commit(SET_DASHBOARD_ROLE, role);
};

// TODO: This action should be deprecated
export const setCourseLoading = ({ commit }, status) => {
  commit(SET_COURSE_LOADING, status);
};

export const setNewCourse = ({ commit }, course) => {
  course.live_discussions = [];
  course.roundtables = [];
  course.users = course.users || [];
  commit(SET_NEW_COURSE, course);
  commit(SET_COURSE_DETAIL, course);
};

// TODO: This action should be deprecated, prefer updateCourseDetail
export const setCourseDetail = ({ commit }, course) => {
  commit(SET_COURSE_DETAIL, course);
  commit(UPDATE_COURSES_LIST, course);
};

export const updateCourseDetail = ({ commit }, payload) => {
  // service to update course
  courseDetailsService
    .updateCourse(payload.id, payload)
    .then((res) => {
      commit(UPDATE_COURSE_DETAIL, res.data);
    })
    .catch(console.err);
};

export const updateRTsCriteria = (_, payload) => {
  // service to update course
  courseDetailsService
    .updateRTsCriteria(payload.id, payload);
};

export const deleteUserFromCourse = ({ commit }, user_id) => {
  commit(DELETE_USER_FROM_COURSE, user_id);
};

export const setCourseStudentActivities = (
  options,
  { courseID, studentID }
) => {
  return courseDetailsService
    .getStudentActivities(courseID, studentID)
    .then(({ activities }) => {
      const sortedActivities = sortBy(activities, [
        (activity) => new Date(activity.published_date), // By published date
      ]);
      return sortedActivities;
    })
    .catch(console.error);
};

export const setMyCourseStudentActivities = (
  options,
  { courseID }
) => {
  return courseDetailsService
    .getMyStudentActivities(courseID)
    .then(({ activities }) => {
      const sortedActivities = sortBy(activities, [
        (activity) => new Date(activity.published_date), // By published date
      ]);
      return sortedActivities;
    })
    .catch(console.error);
};

export const setCourseStudentSkills = (
  options,
  { courseID, studentID, skill, dateStart, dateEnd }
) => {
  return courseDetailsService
    .getStudentSkills(courseID, studentID, skill, dateStart, dateEnd)
    .then(({ activities }) => {
      const sortedActivities = sortBy(activities, [
        (activity) => new Date(activity.published_date), // By published date
      ]);
      return sortedActivities;
    })
    .catch(console.error);
};

export const setMyCourseStudentSkills = (
  options,
  { courseID }
) => {
  return courseDetailsService
    .getMyStudentSkills(courseID)
    .then(({ activities }) => {
      const sortedActivities = sortBy(activities, [
        (activity) => new Date(activity.published_date), // By published date
      ]);
      return sortedActivities;
    })
    .catch(console.error);
};

export const addStudents = (_, payload) => {
  return courseDetailsService.addStudentToCourse(payload.id, payload).then(({ data }) => data);
};

export const addStudentToCourseCSV = (_, payload) => {
  return courseDetailsService.addStudentToCourseCSV(payload.id, payload).then(({ data }) => data);
};

// DeletedArray is an array of students ids of the students
// to be removed from the course
export const removeStudents = ({ commit }, deletedArray) => {
  commit(REMOVE_STUDENTS_FROM_COURSE, deletedArray);
};

export const deleteRT = ({ commit }, id) => {
  commit(DELETE_RT, id);
};

export const deleteCourse = async ({ commit, getters, dispatch }, courseID) => {
  try {
    await courseDetailsService.deleteCourse(courseID);
    commit(DELETE_COURSE, courseID);
    const { getDashboardRole } = getters;
    if (getDashboardRole === 'teacher') {
      if (getters.getProfile.is_paid === false) {
        const response = await loadUserInfo();
        const account = response.data;
        dispatch('setAccount', account);
      }
      dispatch('handleSetInstructorCourses', { role: getDashboardRole, page: 1 });
    }
  } catch (error) {
    console.error(error);
    const toast = { type: 'Error', message: 'Something happened deleting course...', time: 5000 };
    EventBus.$emit('createToast', toast);
    
  }
};

export const archiveCourse = ({ commit, getters, dispatch }, courseID) => {
  return courseDetailsService.archiveCourse(courseID).then(() => {
    commit(ARCHIVE_COURSE, courseID);
    const { getDashboardRole } = getters;
    if (getDashboardRole === 'teacher') {
      dispatch('handleSetInstructorCourses', { role: getDashboardRole, page: 1 });
    }
  });
};

export const gradeClassroomStudents = ({ getters }, payload) => {
  const { activityType } = payload;
  delete payload.activityType;
  if (activityType === 'online') {
    return roundtableService.gradeClassroomStudents(getters.getCurrentRT.id, payload).then((data) => {
      return data;
    });
  }
  return liveDiscussionService.gradeClassroomStudents(getters.getCurrentDiscussion.id, payload).then((data) => {
    return data;
  });
};

export const gradeClassroomStudentsStatus = ({ getters }, payload) => {
  const { jobID } = payload;
  return googleClassroomService.gradeClassroomStudentsJobStatus(getters.getCourseDetail.id, jobID).then((data) => {
    return data;
  });
};

export const gradeEdlinkStudentsStatus = ({ getters }, payload) => {
  const { jobID } = payload;
  return adminServices.gradeEdlinkIntegrationStudentsJobStatus(getters.getCourseDetail.id, jobID).then((data) => {
    return data;
  });
};

// enterCourse is the main action that is called when user steps into course
export const enterCourse = ({ dispatch }, courseID) => {
  return dispatch('fetchCourseDetails', courseID);
};

export const editActivityInCourseState = ({ commit }, payload) => {
  commit(EDIT_ACTIVITY_IN_COURSE_STATE, payload);
};

export const addLiveDiscussionToCourseState = (
  { getters, commit },
  payload
) => {
  if (getters.getCourseDetail.id === payload.course_id) {
    commit(SET_NEW_LIVE_DISCUSSION, payload);
  }
};

export const addRoundtableToCourseState = ({ getters, commit }, payload) => {
  if (getters.getCourseDetail.id === payload.course_id) {
    commit(SET_NEW_ONLINE_ROUNDTABLE, payload);
  }
};


export const togglePinCourse = async ({ getters, dispatch }, { subscriptionID, toggleToTrue }) => {
  await pinCourseService(subscriptionID, toggleToTrue);
  const { getDashboardRole } = getters;
  if (getDashboardRole === 'teacher') {
    router.replace({ query: { page: 1 }});
    await dispatch('handleSetInstructorCourses', { role: getDashboardRole, page: 1 });
    return;
  }
  if (getDashboardRole === 'student') {
    router.replace({ query: { page: 1 }});
    await dispatch('handleSetParticipantCourses', { role: 'student', page: 1 });
    return;
  }
  /* return pinCourseService(subscriptionID, toggleToTrue).then(async ({ data }) => {
    commit(UPDATE_SUBSCRIPTION_TO_COURSE, data);
    return data;
  }); */
};

export const createCourse = ({ dispatch }, payload) =>
  courseDetailsService.createCourse(payload).then((course) => {
    dispatch('analytics', 'create course - create course', {
      routeFrom: router.currentRoute.name,
    });
    dispatch('setCourseLoading', false);
    dispatch('setNewCourse', course);
    const local_storage_premade_id = localStorage.getItem('premade_id');
    if (local_storage_premade_id) {
      localStorage.removeItem('premade_id');
      return dispatch('createOnlineRoundtable', {
        course_id: course.id,
        premade_id: local_storage_premade_id,
      });
    }
    return course;
  });

export const joinCourse = ({ dispatch }, payload) =>
  courseDetailsService.joinCourse(payload).then(({ course }) => {
    dispatch('setNewCourse', course);
    router.push({
      name: 'course.index', //'course.roundtables.default',
      params: { courseID: course.id },
    });
    return course;
  });

export const studentHasJoinedFirstORT = (
  { commit },
  { course_id, user_id }
) => {
  courseDetailsService
    .joinFirstOrtInCourse(course_id, user_id)
    .then(({ data }) => {
      commit(UPDATE_SUBSCRIPTION_TO_COURSE, data);
    });
};

export const studentHasJoinedFirstLRT = (
  { commit },
  { course_id, user_id }
) => {
  courseDetailsService
    .joinFirstLrtInCourse(course_id, user_id)
    .then(({ data }) => {
      commit(UPDATE_SUBSCRIPTION_TO_COURSE, data);
    });
};
export const saveFeedback = async ({ commit }, { course_id, text, roundtable_type }) => {
  /* Accepted Types - ( 'online', 'live' ) */
  const new_feedback = await courseDetailsService.saveFeedback(course_id, text, roundtable_type);
  if (!new_feedback) {
    const toast = { type: 'Error', message: 'Something happened creating template...', time: 5000 };
    EventBus.$emit('createToast', toast);
    return new_feedback;
  }
  commit(roundtable_type === 'online' ? UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION : UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION, {
    data: new_feedback.data,
    isEdit: false
  });
  return new_feedback;
};

export const updateFeedback = async ({ commit }, { course_id, feedback_id, text, roundtable_type }) => {
  const updated_feedback = await courseDetailsService.updateFeedback(course_id, feedback_id, text);
  if (!updated_feedback) {
    const toast = { type: 'Error', message: 'Something happened updating template...', time: 5000 };
    EventBus.$emit('createToast', toast);
    return updated_feedback;
  }
  commit(roundtable_type === 'online' ? UPDATE_SAVED_FEEDBACK_ONLINE_DISCUSSION : UPDATE_SAVED_FEEDBACK_LIVE_DISCUSSION, {
    data: { id: feedback_id, text: text },
    isEdit: true
  });
  return updated_feedback;
};
export const importFeedbackOnline = async ({ commit }, { course_id, courses }) => {
  const courses_imported = await courseDetailsService.importFeedbackOnline(course_id, courses);
  commit(IMPORT_SAVED_FEEDBACK_ONLINE_DISCUSSION, courses_imported.data);
  return courses_imported;
};

export const importFeedbackLive = ({ commit }, { course_id, courses }) =>
  courseDetailsService
    .importFeedbackLive(course_id, courses)
    .then(({ data }) => {
      commit(IMPORT_SAVED_FEEDBACK_LIVE_DISCUSSION, data);
    });

export const deleteFeedback = (
  { commit },
  { course_id, feedback_id, onlineRT }
) => {
  courseDetailsService.deleteFeedback(course_id, feedback_id).then(() => {
    if (onlineRT) {
      commit(DELETE_SAVED_FEEDBACK_ONLINE_DISCUSSION, feedback_id);
    } else {
      commit(DELETE_SAVED_FEEDBACK_LIVE_DISCUSSION, feedback_id);
    }
  });
};

export const syncGoogleClassroomCourse = ({ dispatch, commit, getters }, { course_id, google_classroom_course_id, google_classroom_course_name, classroom_users }) => {
  const payload = {
    google_classroom_course_name,
    classroom_users
  };
  return googleClassroomService.syncGoogleClassroomCourse(course_id, google_classroom_course_id, payload).then(({ data }) => {
    if (data && getters.getCourseDetail.id === course_id) {
      commit(UPDATE_COURSE_DETAIL, { google_classroom_integration: { course_id: google_classroom_course_id, course_name: google_classroom_course_name } });
      dispatch('fetchCourseDetails', course_id);
    }

  });
};

export const unsyncGoogleClassroomCourse = ({ dispatch, getters }, { course_id, removeStudents }) => {
  googleClassroomService.disconnectGoogleClassroomIntegration(course_id, { removeStudents }).then(
    ({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        //TODO: review this
        dispatch('fetchCourseDetails', course_id);
      }
    });
};

export const connectStudentGoogleClassroomIntegration = ({ dispatch, getters }, { course_id, payload }) => {
  googleClassroomService.generateSubscriptionGoogleClassroomTokens(course_id, payload).then(
    ({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        dispatch('fetchCourseDetails', course_id);
        dispatch('updateAccount', { google_integration: { connected: true } });
      }
    });
};

export const disconnectStudentGoogleClassroomIntegration = ({ dispatch, getters }, { course_id }) => {
  googleClassroomService.disconnectStudentGoogleClassroomIntegration(course_id).then(
    ({ data }) => {
      if (data && getters.getCourseDetail.id === course_id) {
        dispatch('fetchCourseDetails', course_id);
        dispatch('updateAccount', { google_integration: {} });
      }
    });
};

export const syncProviderCourse = ({ commit, getters }, { course_id, edlink_course_id, edlink_course_name, users }) => {
  courseDetailsService.importStudentsFromEdlink(course_id, edlink_course_id, users).then(() => {
    if (getters.getCourseDetail.id === course_id) {
      commit(UPDATE_COURSE_DETAIL, { edlink_course_id, edlink_course_name });
    }
  });
};

export const unsyncStudentFromCourse = ({ commit, getters }, { course_id, student_ids }) => {
  googleClassroomService.unsyncGoogleClassroomStudentFromCourse(course_id, { student_ids }).then(({ data }) => {
    if (data && getters.getCourseDetail.id === course_id) {
      const { deleted_students } = data;
      if (deleted_students.length) {
        commit(REMOVE_STUDENTS_FROM_COURSE, deleted_students);
      }
    }
  });
};




// WEBPACK FOOTER //
// ./src/app/store/actions/courses.js